export default "__VITE_ASSET__BFMKnS8d__"